export default {
  val_email: 'El formato no es correcto',
  val_phone: 'Mínimo 9 dígitos',
  val_dni: 'Mínimo 8 caracteres',
  val_user_verification: 'Mínimo 8 caracteres, 1 mayúscula, 1 número y 1 caracter especial.',
  val_empty: 'No puede estar vacío',
  val_clinic: 'Debes elegir una clinica',
  val_empty_data: 'No hay datos representativos',
};
